export function createPricingConfigurationClient(transport) {
    return {
        /**
         * List this tenant's rate-card versions, newest first
         *
         * Requires scope: pricing:configuration:read
         */
        listTenantRateCards(tenantId, status, productId, limit, after, options) {
            return transport.request({
                method: "GET",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/rate-cards`,
                query: { status: status, productId: productId, limit: limit, after: after },
                options,
            });
        },
        /**
         * Create a draft rate card
         *
         * Requires scope: pricing:configuration:write
         */
        postTenantsRateCards(tenantId, body, options) {
            return transport.request({
                method: "POST",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/rate-cards`,
                body,
                options,
            });
        },
        /**
         * Append a governed rate-card version
         *
         * Requires scope: pricing:configuration:write
         */
        postTenantsRateCardsVersions(tenantId, rateCardId, body, options) {
            return transport.request({
                method: "POST",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/rate-cards/${encodeURIComponent(rateCardId)}/versions`,
                body,
                options,
            });
        },
        /**
         * Read one published rate-card version, for reproducing a historical price
         *
         * Requires scope: pricing:configuration:read
         */
        getTenantsRateCardsVersions(tenantId, rateCardId, version, options) {
            return transport.request({
                method: "GET",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/rate-cards/${encodeURIComponent(rateCardId)}/versions/${encodeURIComponent(version)}`,
                options,
            });
        },
        /**
         * Resolve an effective published rate-card version without calculating a quote
         *
         * Requires scope: pricing:configuration:read
         */
        getTenantsRateCardsEffective(tenantId, productId, geographyId, effectiveAt, options) {
            return transport.request({
                method: "GET",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/rate-cards/effective`,
                query: { productId: productId, geographyId: geographyId, effectiveAt: effectiveAt },
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=pricing-configuration.js.map